import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessageWrappedInSpan} from '../misc';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';

import {Checkbox, FormControl, FormControlLabel} from '@material-ui/core';

const GDPRHint = ({className, faceNote, secondFactorNote, onChange, intl}) => {

  const linkToPrivacy = (
    <a href="/privacy" target="_blank" rel="noopener noreferrer">
      <FormattedMessageWrappedInSpan id="gdprHint.link" defaultMessage="privacy policy" />
    </a>
  );

  const linkToSecondFactorFAQ = (
    <a href={`https://helpdesk.sportograf.com/${intl.locale}/support/solutions/articles/77000530756`} target="_blank" rel="noopener noreferrer">
      <FormattedMessageWrappedInSpan id="gdprHint.secondFactorHint.link" defaultMessage="our second factor authentication" />
    </a>
  )

  return (
    <>
      {faceNote &&
        <div className={classNames('gdpr-hint-consent', className)}>
          <FormControl component="fieldset">
            <FormControlLabel
              control={<Checkbox onChange={onChange}/>}
              label={
                <FormattedMessageWrappedInSpan
                  id="gdprHint.faceHint"
                  defaultMessage="I consent that the uploaded selfie which depicts me with regard to biometric features (especially face vectors), will be matched with our database of the corresponding event. The consent can be revoked at any time with effect for the future by notifying Sportograf."
                />
              }
              labelPlacement="end"
            />
          </FormControl>
        </div>
      }
      {secondFactorNote &&
        <div className={classNames('gdpr-hint-text', className)}>
          <FormattedMessageWrappedInSpan
            id="gdprHint.secondFactorHint.text"
            defaultMessage="Why do we ask for this? Learn more about {link} and how we process your data."
            values={{link: linkToSecondFactorFAQ}}
          />
        </div>
      }
      {!faceNote && !secondFactorNote &&
        <div className={classNames('gdpr-hint-text', className)}>
          <FormattedMessageWrappedInSpan
            id="gdprHint.text"
            defaultMessage="For more information on data protection, please see our {link}."
            values={{link: linkToPrivacy}}
          />
        </div>
      }
    </>
  );
};

GDPRHint.defaultProps = {
  faceNote: false,
  secondFactorNote: false
};

GDPRHint.propTypes = {
  intl: PropTypes.object,
  className: PropTypes.string,
  faceNote: PropTypes.bool,
  secondFactorNote: PropTypes.bool,
  onChange: PropTypes.func
};

export default injectIntl(GDPRHint);
